<template>
	<div id="reg" class="formstep col-12">
		<b-modal
			id="payer-type-modal"
			v-model="isVisibleResetModal"
			size="sm"
			title="Заполнить форму заново"
			centered
			hide-footer
		>
			<div v-if="isLoading" class="text-center">
				<b-spinner variant="primary" />
			</div>
			<template v-else>
				<div class="text-center mb-4">
					Вы уверены, что хотите сбросить данные формы и заново её заполнить?
				</div>
				<div class="d-flex justify-content-center">
					<b-button variant="outline-primary" class="col-4 mr-2" @click="reset">
						Да
					</b-button>
					<b-button variant="primary" class="col-4" @click="isVisibleResetModal = false">
						Нет
					</b-button>
				</div>
			</template>
		</b-modal>
		<b-modal
			id="reset-promocode-modal"
			v-model="isVisiblePromocodeModal"
			size="sm"
			title="Промокод может быть сброшен"
			centered
			hide-footer
			@close="setVisibilityPromocodeModal(false)"
		>
			<div class="text-center mb-4">
				Вы уверены, что хотите изменить данные? Промокод будет сброшен
			</div>
			<div class="d-flex justify-content-center">
				<b-button variant="outline-primary" class="col-4 mr-2" @click="removePromocode">
					Да
				</b-button>
				<b-button variant="primary" class="col-4" @click="setVisibilityPromocodeModal(false)">
					Нет
				</b-button>
			</div>
		</b-modal>

		<template v-if="currentStep !== STEPS.FINISH">
			<div class="mb-2 mb-lg-5">
				<div v-if="block.block_title" class="row panel_header align-items-start">
					<div class="col-12 col-lg-9">
						<h2 class="mb-0">
							{{ block.block_title }}
						</h2>
					</div>
				</div>
			</div>
			<div v-if="block.subtitle" class="col-12">
				<p>{{ block.subtitle }}</p>
			</div>

			<client-only>
				<div
					v-if="isShowProducts"
					class="mb-4"
				>
					<div class="title mb-4">
						Выбор потока программы
					</div>
					<products-component
						v-model="products"
						class="products-list"
						:block="block"
						@input="productChangeHandler"
					/>
				</div>
				<div id="reg" class="row h-100 mt-2 mt-lg-4">
					<div ref="sticky-container" class="col-12 col-lg-2 sticky-container">
						<ProgressSteps
							:steps="stepsListFormatted"
							:current="currentStep"
							:error="isStepError"
							dynamic-index
							@change="stepHandler"
						>
							<div class="price-block py-3 px-4 mb-3 text-white text-center">
								<span
									class="title"
									:class="{ 'mb-lg-2 mr-2': !isFreePromocode }"
								>{{ displayableTotalPrice }}</span>
								<div
									v-if="isShowTaxInfo"
									class="d-flex align-items-center small"
								>
									<span class="text-white">
										Можно получить налоговый вычет
									</span>
								</div>
							</div>
						</ProgressSteps>
					</div>
					<div v-if="currentStep === 1 || order" class="col-12 col-lg-8 py-0 px-lg-4">
						<KeepAlive>
							<component
								:is="currentComponent"
								:ref="currentComponent"
								:block="block"
								:fetched-data="fetchedData"
								:order="order"
								@updateOrder="getCurrentOrder(orderHash)"
								@reset="showResetModal"
							/>
						</KeepAlive>
					</div>
					<!--  Блок информации  -->
					<div class="col-12 col-lg-2 d-flex justify-content-center align-items-start">
						<template
							v-if="currentInformationBlock"
						>
							<component
								:is="`${currentInformationBlock}Information`"
							/>
						</template>
						<FirstStepInformation
							v-else-if="orderHash"
							title=""
							class=""
							submit-title="Сбросить всё"
							custom-submit
							@submit="showResetModal"
						/>
					</div>
				</div>
			</client-only>
		</template>
		<div v-else class="d-flex justify-content-center">
			<client-only>
				<SuccessStep
					:fetched-data="fetchedData"
					:block="block"
					@updateOrder="getCurrentOrder(orderHash)"
				/>
			</client-only>
		</div>
	</div>
</template>

<script>
import ProgressSteps from '~/components/panels/formulate/components/ProgressSteps.vue';
import AuthStep from '~/components/panels/formulate/components/steps-new/AuthStep.vue';
import AuthStepWithId from '~/components/panels/formulate/components/steps-new/AuthStepWithId.vue';
import FirstStep from '~/components/panels/formulate/components/steps-new/FirstStep.vue';
import SecondStep from '~/components/panels/formulate/components/steps-new/SecondStep.vue';
import ThirdStep from '~/components/panels/formulate/components/steps-new/ThirdStep.vue';
import SuccessStep from '~/components/panels/formulate/components/steps-new/SuccessStep.vue';
import CompanyStep from '~/components/panels/formulate/components/steps-new/CompanyStep.vue';

import FirstStepInformation from '~/components/panels/formulate/components/steps-new/informationBlocks/FirstStepInformation.vue';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';

import formulateFormScenario from '~/mixins/formulateFormScenario';
import loyaltyPoints from '~/mixins/loyaltyPoints';
import paymentFormMixin from '~/mixins/paymentFormMixin';
import { createMaskAmount } from '~/utils/intl-converter';

import { LOYALTY_LEVELS } from '~/utils/dictionaries';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

export default {
	name: 'LandingProgramWithStepsNewPaymentScenario',
	components: {
		AuthStep,
		AuthStepWithId,
		ProgressSteps,
		FirstStep,
		SecondStep,
		ThirdStep,
		SuccessStep,
		CompanyStep,
		FirstStepInformation,
		ProductsComponent,
	},
	mixins: [paymentFormMixin, formulateFormScenario, loyaltyPoints],
	provide() {
		const order = {};

		Object.defineProperty(order, 'data', {
			enumerable: true,
			get: () => this.order?.data,
		});

		Object.defineProperty(order, 'unauthAgreements', {
			enumerable: true,
			get: () => this.order.unauthAgreements,
		});

		Object.defineProperty(order, 'chargedPoints', {
			enumerable: true,
			get: () => this.order.chargedPoints,
		});

		Object.defineProperty(order, 'chargedPremiumPoints', {
			enumerable: true,
			get: () => this.order.chargedPremiumPoints,
		});

		return {
			order,
		};
	},
	data() {
		return {
			levels: LOYALTY_LEVELS,
			loyaltyProfile: {},
			order: {
				data: {
					products: [],
				},
			},
			isVisibleResetModal: false,
		};
	},
	computed: {
		...mapState('scenarios/paymentForm', [
			'currentStep',
			'isLoading',
			'orderHash',
			'isCompletedFieldsDisabled',
			'isStepError',
			'price',
			'isVisiblePromocodeModal',
			'currentPromocode',
		]),
		...mapGetters('scenarios/paymentForm', [
			'stepsList',
			'totalPrice',
			'currentRedirectStep',
			'isRepresentative',
			'isNoEducation',
			'isFreePromocode',
			'isPhysicalPayer',
			'isRequiredVat',
		]),
		currentComponent() {
			return this.STEPS_COMPONENT[this.currentStep];
		},
		stepsListFormatted() {
			return this.stepsList.filter((step) => (this.$auth.user ? step.id !== 0 : true));
		},
		productPrice() {
			return this.block.products[0]?.price || 0;
		},
		productPriceWithVat() {
			return this.block.products[0]?.program_price_with_vat || 0;
		},
		currentInformationBlock() {
			if (this.orderHash) return false;
			const isInfoStep = [this.STEPS_COMPONENT.info]
				.find((block) => this.currentComponent === block) ?? null;
			return this.isRepresentative ? null : this.isCompletedFieldsDisabled && isInfoStep;
		},
		displayableTotalPrice() {
			const price = (this.price.withLoyalty || this.price.withLoyalty === 0)
				? this.price.withLoyalty
				: this.totalPrice;
			const total = createMaskAmount(price);

			return (total === '') ? 'Бесплатно' : `${total} руб`;
		},
		invoice() {
			return this.order.data?.invoices[0];
		},
		isShowProducts() {
			return !this.$auth.user && this.block.products.length > 1;
		},
		isShowTaxInfo() {
			return !this.isFreePromocode && !this.isNoEducation && !this.isRequiredVat;
		},
	},
	watch: {
		'$auth.user': {
			async handler(value) {
				if (value) {
					await this.getPersonData(this.block.scenario_id);
				}
			},
			immediate: true,
		},
		orderHash: {
			handler(value) {
				if (value) {
					this.getCurrentOrder(value);
				}
			},
			immediate: true,
		},
		currentStep: {
			handler() {
				setTimeout(() => {
					if (!process.client) return;
					if (this.currentStep === this.STEPS.FINISH) this.$scrollTo('#reg', { offset: -100 });
				});
			},
			immediate: true,
		},
	},
	async created() {
		const product = this.block?.products[0];
		if (product) this.setProduct(product);

		this.setPrice({ value: this.productPrice, key: 'initial' });
		this.setPrice({ value: this.productPriceWithVat, key: 'withVat' });
		this.checkHashInUrl();
		this.checkNewAuthForm();
	},
	methods: {
		...mapActions('scenarios/paymentForm', [
			'getPersonData',
			'setCurrentStep',
			'resetForm',
		]),
		...mapMutations('scenarios/paymentForm', [
			'setStep',
			'setPrice',
			'setRedirectStep',
			'setOrderHash',
			'setLoading',
			'setPromocode',
			'setVisibilityPromocodeModal',
			'setProduct',
		]),
		createMaskAmount,
		async stepHandler(step) {
			if (this.currentPromocode.isActive) {
				const redirectStep = this.isPhysicalPayer ? this.STEPS.DOCUMENTS : this.STEPS.COMPANY;

				this.setRedirectStep(redirectStep);
				this.setVisibilityPromocodeModal(true);
				return;
			}
			if (this.isLoading) return;

			const currentStepComponent = this.$refs[this.STEPS_COMPONENT[this.currentStep]];
			if (currentStepComponent && currentStepComponent.validate) {
				this.setRedirectStep(step);
				await currentStepComponent.validate();
				return;
			}
			await this.setCurrentStep(step);
		},
		async getCurrentOrder(hash) {
			let fetchedData = null;

			try {
				this.order = await this.$api.orderInfo(hash);
				const {
					amount,
					amount_without_vat: amountWithoutVat,
					promocode,
					price_with_manager_vat: priceVat,
					products,
				} = this.order.data;
				const price = this.isPhysicalPayer ? amountWithoutVat : amount;

				if (amount) {
					this.setPrice({ value: price, key: 'initial' });
					this.setPrice({ value: priceVat, key: 'withVat' });
				}
				if (this.order.data?.landing) {
					fetchedData = await this.$api.event(this.order.data.landing.slug);
				}
				if (promocode) {
					const { promocode: promo } = promocode;

					this.setPromocode({ isActive: true, value: promo });
					this.setPrice({ value: amount, key: 'withPromocode' });
				}
				if (products?.length) {
					this.setProduct(products[0]);
				}
			} catch (error) {
				console.error(error);

				const { hash: routeHash } = this.$route.query;
				if (routeHash) {
					window.location.replace(this.$route.path);
				}
			}
		},
		checkHashInUrl() {
			const { hash } = this.$route.query;

			if (hash) {
				this.setOrderHash(hash);
				this.setStep(this.STEPS.FINISH);
			}
		},
		showResetModal() {
			this.isVisibleResetModal = true;
		},
		async reset() {
			this.setLoading(true);
			await this.resetForm();
			this.setLoading(false);
			this.isVisibleResetModal = false;
			window.location.reload();
		},
		async removePromocode() {
			await this.resetPromocodeForm(this.currentPromocode.value, this.invoice.reference);
			this.setVisibilityPromocodeModal(false);
			this.setStep(this.currentRedirectStep);
		},
		checkNewAuthForm() {
			if (this.$auth.user) return;

			const { skolkovoId } = this.$route.query;
			if (skolkovoId) {
				this.setStep(this.STEPS.LOGIN_ID);
			}
		},
	},
};
</script>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

$base-color: #ACB5C7;

.formstep {
	display: flex;
	flex-direction: column;

	.price-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: mediumseagreen;
		border-radius: .5rem;
	}

	padding-bottom: 5rem;

	.formulate-input {
		.formulate-input-label {
			color: $body-color;
			line-height: 1 !important;
			font-size: 80% !important;
			font-weight: 400 !important;
			margin-bottom: 0.5rem;
		}
	}

	.price_vat {
		color: $border-color;
		font-size: 0.8rem;
		line-height: 1rem;
	}

	.submit {
		button {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.icon-wrapper {
		padding: 0.6rem 0.5rem 0.5rem 0.6rem;
		width: 1.5rem;
		height: 1.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 0.5rem;
		background-color: $base-color;
		border-radius: 50%;
		color: white;
	}

	.font-gray-bold {
		font-weight: 500;
		color: $base-color;
	}

	.sticky-container {
		@include media-breakpoint-up(lg) {
			height: 100% !important;
		}
	}

	.btn-link {
		text-decoration: underline;
	}
}

</style>
